export default __webpack_public_path__ + "static/media/help-one.e56b462a.png";